<template>
	<v-card 
		class="elevation-8 pt-10 pb-10 pl-5 pr-5"
		height="480px"
	>
		<v-img 
			height="90" 
			contain 
			src="@/assets/logo.png"
		>
			
		</v-img>
		<v-card-title
			class="font-weight-black justify-center"
		>
			{{form_title}}
		</v-card-title>

		<template v-if="is_auth">
			<v-card-subtitle
				class="font-weight-black text-center mt-0"
			>
				{{form_subtitle}}
			</v-card-subtitle>

			<v-card-text>
				<v-text-field
					id="password"
					prepend-icon="mdi-lock"
					name="password"
					:label="password_label_text"
					:type="password_type"
					v-model="password"
					@keyup.enter="resetPwd"
					:append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
					@click:append="toggleShowPassword"
				></v-text-field>

				<v-text-field
					id="password"
					prepend-icon="mdi-lock"
					name="password"
					:label="password_confirm_label_text"
					:type="confirm_password_type"
					v-model="password_confirm"
					@keyup.enter="resetPwd"
					:append-icon="show_password_confirm ? 'mdi-eye' : 'mdi-eye-off'"
					@click:append="toggleShowPasswordConfirm"
				></v-text-field>		
			</v-card-text>
			<v-card-actions
				class="justify-center"
			>
				<v-btn
					outlined
					color="#ee5e58"
					class="pl-10 pr-10"
					@click="resetPwd"
				>
					{{form_action_btn_text}}
				</v-btn>
			</v-card-actions>	
		</template>	

		<template v-else>
			<v-card-subtitle
				class="font-weight-black text-center mt-0"
			>
				您無權訪問此頁
			</v-card-subtitle>
		</template>				
	</v-card>
</template>
<script>
import {
	apiResetPwd
} from '@/api/user.js'

	export default {
		name: 'UserResetPwd',
		components: {
		},
		created: async function() {
			this.initPage()
			console.log(this.$route.query)

			let access_token = this.$route.query.access_token.replace(' ', '+')
			if (!access_token) {
				return
			}

			let result = await this.checkAccessToken(access_token)
			if (result) {
				this.is_auth = true
			}
			else {
				this.is_auth = false
			}

		},
		mounted: function() {
		},
		data: function() {
			return {
				// 登入視窗標題
				form_title: '',

				// 登入視窗副標題
				form_subtitle: '',

				// 密碼的數值
				password: '',

				// 密碼輸入框的標題文字
				password_label_text: '',

				// 密碼的數值
				password_confirm: '',

				// 密碼輸入框的標題文字
				password_confirm_label_text: '',

				// 登入按鈕的文字
				form_action_btn_text: '',

				is_auth: false,

				show_password_confirm: false,
				show_password: false,
				password_type: "password",
				confirm_password_type: "password",
		
			}
		},
		methods: {		
			initPage: function() {
				this.form_title           = 'Optimize99'
				this.form_subtitle        = '重設密碼'
				this.password             = ''
				this.password_label_text  = '密碼'
				this.password_confirm     = ''
				this.password_confirm_label_text  = '確認密碼'
				this.form_action_btn_text = '更新'
			},
			checkAccessToken: async function(access_token){
				let result = false
				let param = {
					token: access_token,
					password: 'string',
					is_check: true
				}
				result = await apiResetPwd(param).then(function(resp){
					let data = resp.data
					console.log(data)
					if (data.ok === 0) {
						return false
					}
					else {
						return true
					}
				}).catch(function(error){
					console.error(error)
					return false
				})
				return result
			},
			resetPwd: async function(){
				let that = this
				if (!this.password) {
					this.$root.vtoast.show({
						message: "請填寫密碼"
					})
					return
				}

				if (!this.password) {
					this.$root.vtoast.show({
						message: "請填寫確認密碼"
					})
					return
				}

				if (this.password !== this.password_confirm) {
					this.$root.vtoast.show({
						message: "兩次密碼不一致"
					})
					return
				}

				let access_token = this.$route.query.access_token.replace(' ', '+')

				let param = {
					password: this.password,
					is_check: false,
					token: access_token
				}

				apiResetPwd(param).then(function(){
					that.$root.vtoast.show({
						message: '密碼重設成功，下次登入請使用新密碼！'
					})

					setTimeout(function(){
						that.$router.push('/login')
					}, 1000)
					
				}).catch(function(error){
					that.$root.vtoast.show({
						message: "密碼重設失敗，原因: " + error.response ? error.response.data : error
					})
				})
			},
			toggleShowPassword: function(){
				if (this.show_password) {
					this.show_password = false
					this.password_type = 'password'
				}
				else {
					this.show_password = true
					this.password_type = 'text'
				}
			},
			toggleShowPasswordConfirm: function(){
				if (this.show_password_confirm) {
					this.show_password_confirm = false
					this.confirm_password_type = 'password'
				}
				else {
					this.show_password_confirm = true
					this.confirm_password_type = 'text'
				}
			}
			
		}
	};
</script>
<style>
	
</style>